import Helper from './Helper';

class InteractiveMapAccordion {
  constructor(config = {}) {
    const {
      accordions,
      accordionsWrapper,
      accordionsTitel,
      accordionsContent,
      pxCorrection
    } = config;
    this.pxCorrection = pxCorrection;
    this.accordionsTitel = accordionsTitel;
    this.accordionsContent = accordionsContent;
    this.accordions = accordions;
    this.accordionsWrapper = Array.prototype.slice.call(document.querySelectorAll(accordionsWrapper));
    this.activeClassName = 'open';

    if (this.accordionsWrapper && this.accordionsWrapper.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.accordionsWrapper.forEach((el, indexOuter) => {
      const accordionInner = el.querySelectorAll(this.accordions);
      accordionInner.forEach((element, index)=>{
        let title = element.querySelector(this.accordionsTitel);
        this.initialize(title, index)
        this.toggleAccordion(title);
      });
    });
  }

  initialize(title, index) {
    if (index === 0) {
      title.classList.add(this.activeClassName);
      Helper.slideOpen(title.nextElementSibling, true);
      title.nextElementSibling.classList.add(this.activeClassName);
    } else {
      Helper.slideClose(title.nextElementSibling);
      title.classList.remove(this.activeClassName);
      title.nextElementSibling.classList.remove(this.activeClassName);
    }
  }

  toggleAccordion(title) {
    title.addEventListener("click", e => {
      if (title.classList.contains(this.activeClassName)) {
        Helper.slideClose(title.nextElementSibling);
        title.classList.remove(this.activeClassName);
        title.nextElementSibling.classList.remove(this.activeClassName);
      } else {
        document.querySelectorAll(this.accordionsTitel).forEach(titel => { titel.classList.remove(this.activeClassName); });
        document.querySelectorAll(this.accordionsContent).forEach(content => { Helper.slideClose(content); });
        title.classList.add(this.activeClassName);
        Helper.slideOpen(title.nextElementSibling, true);
        title.nextElementSibling.classList.add(this.activeClassName);
      }
    });
  }
}

export default InteractiveMapAccordion;
